import { InjectionToken } from '@angular/core';
import { StoreConfig } from '@ngrx/store';

import * as fromAccounts from './state/accounts.reducer';

export const ACCOUNTS_STORAGE_KEYS = new InjectionToken<
  keyof fromAccounts.State
>('AccountsStorageKeys');
export const ACCOUNTS_STORAGE_KEY = new InjectionToken<string[]>(
  'AccountsStorage',
);
export const ACCOUNTS_CONFIG_TOKEN = new InjectionToken<
  StoreConfig<fromAccounts.State>
>('AccountsConfigToken');
